import { type GetterTree } from 'vuex';

import { DEFAULT_KEY } from './constants';
import { type ILeadState } from './types';

export const GET_AGGREGATION_BY_STATUS_TOTAL = 'getAggregationByStatusTotal';
export const GET_AGGREGATION_BY_ALL_STATUS = 'getAggregationByAllStatus';
export const GET_AGGREGATION_BY_STATUS = 'getAggregationByStatus';
export const GET_AGGREGATION_BY_TYPE_TOTAL = 'getAggregationByTypeTotal';
export const GET_AGGREGATION_BY_TYPE = 'getAggregationByType';
export const GET_AGGREGATION_BY_STAGE = 'getAggregationByStage';
export const GET_AGGREGATION_BY_ORIGIN_ENTITY = 'getAggregationByOriginEntity';

export const getters: GetterTree<ILeadState, unknown> = {
    [GET_AGGREGATION_BY_STATUS_TOTAL]: (_state) => {
        return (key = DEFAULT_KEY): number => {
            return _state.aggregationByStatus[key]?.totalCount ?? 0;
        };
    },
    [GET_AGGREGATION_BY_ALL_STATUS]: (_state) => {
        return (key = DEFAULT_KEY): Record<string, number> => {
            return _state.aggregationByStatus[key]?.byStatus;
        };
    },
    [GET_AGGREGATION_BY_STATUS]: (_state) => {
        return (status: string, key = DEFAULT_KEY): number => {
            return _state.aggregationByStatus[key]?.byStatus[status] ?? 0;
        };
    },
    [GET_AGGREGATION_BY_TYPE_TOTAL]: (_state) => {
        return (key = DEFAULT_KEY): number => {
            return _state.aggregationByType[key]?.totalCount ?? 0;
        };
    },
    [GET_AGGREGATION_BY_TYPE]: (_state) => {
        return (typeId: number, key = DEFAULT_KEY): number => {
            return _state.aggregationByType[key]?.byType[typeId.toString()] ?? 0;
        };
    },
    [GET_AGGREGATION_BY_STAGE]: (_state) => {
        return (stageId: number, key = DEFAULT_KEY): number => {
            return _state.aggregationByStage[key]?.byStage[stageId.toString()] ?? 0;
        };
    },
    [GET_AGGREGATION_BY_ORIGIN_ENTITY]: (_state) => {
        return (originEntityId: number, key = DEFAULT_KEY): number => {
            return _state.aggregationByOriginEntity[key]?.byOriginEntity[originEntityId.toString()] ?? 0;
        };
    }
};
